import React from 'react';
import { format } from 'date-fns';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import { MONTH_DASH_YEAR_FORMAT, MONTH_DAY_YEAR_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import ICellProps, { ITranchRow } from './ICellProps';
import { deprecatedParseLegacyDateString } from '@framework/date-helpers/parseDateString';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: { maturityDate } } : ITranchRow) => (
  maturityDate
      ? format(
          deprecatedParseLegacyDateString(maturityDate.dateTime, maturityDate.timezone.timeZone),
          MONTH_DASH_YEAR_FORMAT,
      )
    : '-'
);

const MaturityCell = ({ rowIndex, tranche } : ICellProps) => {
  const { maturityDate } = tranche;

  if (maturityDate) {
    return (
      <Tooltip
        disabled={ !maturityDate }
        content={ format(
            deprecatedParseLegacyDateString(maturityDate.dateTime, maturityDate.timezone.timeZone),
            MONTH_DAY_YEAR_FORMAT,
        ) }
      >
        <BodyCell
          name="MaturityCell"
          className={ alignStyles.alignCenter }
          rowIndex={ rowIndex }
          rowData={ tranche }
          cellCallback={ getCell }
        />
      </Tooltip>
    );
  }
  return (
    <BodyCell
      name="MaturityCell"
      className={ alignStyles.alignCenter }
      rowIndex={ rowIndex }
      rowData={ tranche }
      cellCallback={ getCell }
    />
  );
};

export default MaturityCell;
